import { CatalogData } from './definitions'

export const catalogData: CatalogData = [
  {
    label: '1',
    desc: 'Sarah',
    children: [
      {
        label: '1.1',
        desc: 'Thomas',
        children: [
          {
            label: '1.1.1',
            desc: 'Robert',
            children: [
              {
                label: '1.1.1.1',
                desc: 'Someone',
                children: [],
              },
            ],
          },
          {
            label: '1.1.2',
            desc: 'Karen',
            children: [],
          },
        ],
      },
    ],
  },
  {
    label: '2',
    desc: 'Sarah',
    children: [
      {
        label: '2.1',
        desc: 'Thomas',
        children: [
          {
            label: '2.1.1',
            desc: 'Robert',
            children: [
              {
                label: '2.1.1.1',
                desc: 'Someone',
                children: [],
              },
            ],
          },
          {
            label: '2.1.2',
            desc: 'Karen',
            children: [],
          },
        ],
      },
    ],
  },
]
